import { Switch } from "antd";
import {
  StyledProfileSettings,
  StyledSettingList,
  StyledSettingListItem,
} from "../../index.styled";
import { useIntl } from "react-intl";
import { useCallback, useState } from "react";
import TwoFactorModal from "./Modal";
import { toast } from "react-toastify";
import { apiAuthTwoFactorTurnOff } from "@lib/api/auth";
import { useMutation } from "@tanstack/react-query";
import { AppCard, AppLoader } from "@lib/components/AppComponents";
import { MyProfileTabProps } from "..";

const MySettings = ({ query, loading }: MyProfileTabProps) => {
  const { messages } = useIntl();
  const apiData = query?.data?.data;
  const [openModal, setOpenModal] = useState<boolean>(false);

  const toggle = useCallback(
    (status?: boolean) => {
      if (typeof status !== "undefined") setOpenModal(status);
      else setOpenModal(!openModal);
    },
    [openModal],
  );

  const turnOffTwoFactorMutation = useMutation({
    mutationFn: apiAuthTwoFactorTurnOff,
    onSuccess() {
      toast.success(
        (messages["common.removedMessage"] as string).replace(
          "{name}",
          messages["common.twoFactor"] as string,
        ),
      );
    },
  });

  const handleSubmitTwoFactor = async (status: boolean) => {
    if (status) {
      toggle(true);
    } else {
      turnOffTwoFactorMutation.mutateAsync(apiData?.id);
      query.refetch();
    }
  };

  if (query.isLoading) return <AppLoader />;

  return (
    <AppCard style={{ padding: "20px" }} loading={loading}>
      <StyledProfileSettings className="profile-notification">
        <StyledSettingList>
          <StyledSettingListItem>
            <Switch
              checked={apiData?.isTwoFactorAuthEnabled}
              onChange={handleSubmitTwoFactor}
            />
            <label className="label">
              {messages["common.twoFactor"] as string}
            </label>
          </StyledSettingListItem>
        </StyledSettingList>
      </StyledProfileSettings>

      <TwoFactorModal
        openModal={openModal}
        toggleModal={toggle}
        query={query}
      />
    </AppCard>
  );
};

export default MySettings;
